/* Enhance the existing Shopify banner. The SDK owns consent, cookies and regional rules. */
(() => {
  if (window.fahrkonturPrivacyReady) return;
  window.fahrkonturPrivacyReady = true;
  // Only translate known English Shopify defaults. Merchant-specific copy is preserved.
  const translations = new Map([
    ['Cookie consent','Cookies & Datenschutz'],['Privacy Policy','Datenschutzerklärung'],
    ['We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them. Learn more in our',
      'Wir und unsere Partner, einschließlich Shopify, verwenden Cookies und ähnliche Technologien für Personalisierung, Werbung und Analysen erst mit deiner Einwilligung. Mehr dazu in unserer'],
    ['Manage preferences','Einstellungen'],['Accept','Akzeptieren'],['Decline','Ablehnen'],
    ['Cookie and privacy preferences','Deine Cookie-Einstellungen'],['Accept all','Alle akzeptieren'],['Decline all','Alle ablehnen'],['Save my choices','Auswahl speichern'],
    ['You control your data','Du entscheidest.'],['Learn more about the cookies we use, and choose which cookies to allow.','Wähle, welche optionalen Cookies du erlaubst. Du kannst deine Auswahl jederzeit ändern.'],
    ['Required','Notwendig'],['Personalization','Personalisierung'],['Analytics','Analysen'],
    ['These cookies are necessary for the site to function properly, including capabilities like logging in and adding items to the cart.','Diese Cookies ermöglichen grundlegende Funktionen wie Anmeldung und Warenkorb. Sie sind für den Shop erforderlich.'],
    ['These cookies store details about your actions to personalize your next visit to the website.','Diese Cookies speichern Einstellungen, um deinen nächsten Besuch zu personalisieren.'],
    ['These cookies are used by us and our partners, including Shopify, to optimize marketing communications and show you ads on other websites.','Wir und unsere Partner, einschließlich Shopify, verwenden diese Cookies für Marketing und Werbung auf anderen Websites.'],
    ['These cookies help us understand how you interact with the site. We use this data to identify areas to improve.','Diese Cookies helfen uns zu verstehen, wie der Shop genutzt wird, und ihn zu verbessern.']
  ]);
  const roots = '#shopify-pc__banner, #shopify-pc__prefs__dialog';
  function translate(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script,style')) continue;
      const text = node.textContent.trim(), replacement = translations.get(text);
      if (replacement) node.textContent = node.textContent.replace(text, replacement);
    }
    root.querySelector('#shopify-pc__prefs__header-close')?.setAttribute('aria-label','Cookie-Einstellungen schließen');
    const title = root.querySelector('h2[id]');
    if (title && !root.hasAttribute('aria-label')) root.setAttribute('aria-labelledby',title.id);
  }
  function sync() { document.querySelectorAll(roots).forEach(translate); }
  const observer = new MutationObserver(records => {
    if (records.some(record => record.target.parentElement?.closest(roots) || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.(roots) || node.querySelector?.(roots))))) sync();
  });
  observer.observe(document.body,{childList:true,subtree:true,characterData:true});
  sync();
  window.addEventListener('pagehide',()=>observer.disconnect());
  window.addEventListener('pageshow',()=>{observer.observe(document.body,{childList:true,subtree:true,characterData:true});sync();});
  document.addEventListener('click',async event => {
    const button = event.target.closest('[data-fk-cookie-settings]');
    if (!button || button.disabled) return;
    const menu = button.closest('fahrkontur-navigation');
    // Release the menu's native top layer before the SDK opens its own dialog.
    menu?.closeMenu?.(true);
    button.disabled = true;
    const existingMessage = button.parentElement.querySelector('.fk-cookie-feedback');
    existingMessage?.remove();
    try {
      if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Privacy UI unavailable');
      await window.privacyBanner.showPreferences();
      sync();
    } catch {
      // No fabricated success and no fallback that silently changes consent.
      const message = document.createElement('p');
      message.className='fk-cookie-feedback';message.setAttribute('role','status');
      message.textContent='Die Cookie-Einstellungen konnten nicht geöffnet werden. Bitte lade die Seite neu und versuche es erneut.';
      button.parentElement.append(message);
      if (menu) { menu.openMenu?.(); button.focus({preventScroll:true}); }
    } finally { button.disabled = false; }
  });
})();
